import { semiconductorManufacturerAliases } from "@buildwithflux/constants";
export function getNormalizedManufacturerName(content) {
    return getNormalizedManufacturer(content)?.name;
}
export function getNormalizedManufacturerLegalName(content) {
    return getNormalizedManufacturer(content)?.legalName;
}
export function getNormalizedManufacturerWebsite(content) {
    return getNormalizedManufacturer(content)?.website;
}
export function getNormalizedManufacturer(content) {
    if (content?.toLowerCase().includes("fill in")) {
        return undefined;
    }
    return semiConductorManufacturerAliasesMatchers.find(({ regex }) => regex.test(content));
}
const semiConductorManufacturerAliasesMatchers = semiconductorManufacturerAliases.map(({ name, legalName, website, match }) => {
    // Escape all special characters (eg. "Texas Instruments Inc." -> "Texas Instruments Inc\.")
    const possibleMatches = [name, legalName, ...match].map((str) => str.replace(/[\\^$*+?.()|[\]{}]/g, "\\$&"));
    const regex = new RegExp(`\\b(${possibleMatches.join("|")})s?\\b`, "i");
    return { name, legalName, website, regex };
});
//# sourceMappingURL=manufacturerAliases.js.map